import { redirect } from 'react-router';

import { RequireAuthentication } from 'containers/RequireAuthentication';
import { getHorizonUserEnvironmentPromiseFromContext } from 'horizon/utils/getHorizonUserEnvironmentPromiseFromContext';
import { isRenderingHorizonServer } from 'rendering/state/renderingState';
import type { HorizonLoaderFunctionArgs } from 'routing/types/HorizonLoaderFunctionArgs';

import { BuyCreditsLinksLoadable } from './BuyCreditsLinksLoadable';

export async function loader({
  request,
  context,
}: HorizonLoaderFunctionArgs<void>) {
  if (isRenderingHorizonServer()) {
    const userEnvironment = await getHorizonUserEnvironmentPromiseFromContext({
      request,
      context,
    });

    if (!userEnvironment.user) return redirect('/login');
  }

  await BuyCreditsLinksLoadable.load();
}

export default function OrgDashboardBuyCreditsLinksHorizonRoute() {
  return (
    <RequireAuthentication>
      <BuyCreditsLinksLoadable />
    </RequireAuthentication>
  );
}
